import { AfterViewInit, Component, Input, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmModel {
  title: string;
  list: {label: string, value: any}[];
}

@Component({
  selector: 'app-modal-mat-list',
  templateUrl: './modal-mat-list.component.html',
  styleUrls: ['./modal-mat-list.component.scss']
})
export class ModalMatListComponent {
  @Input() title: string = "";
  @Input() list: {label: string, value: any}[] = [];

  public objectKeys = Object.keys;

  constructor(public dialogRef: MatDialogRef<ModalMatListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmModel) {
    this.title = this.data?.title || '';
    if(this.data?.list && this.data?.list.length > 0){
      this.list = this.data?.list;
    }
  }
  

  validateRutType(label: string): boolean {
    if(label) {
      return label.includes('Rut');
    }
    return false;
  }

  //confirm
  confirm() {
    this.dialogRef.close(true);
  }

  //cancel
  close() {
    this.dialogRef.close(false);
  }
}
